export default {
	yijian: [
		// 	{
		// 	id: 1,
		// 	name: '智慧养老服护实训项目',
		// 	cid: '',
		// 	textContext: '',
		// 	address: '',
		// 	loginID: '',
		// 	password: '',
		// 	viewCount:888,
		// 	createTime: '2023-03-15'
		// }, {
		// 	id: 2,
		// 	name: '云端智能康复项目',
		// 	cid: '',
		// 	textContext: '',
		// 	address: '',
		// 	loginID: '',
		// 	password: '',
		// 	viewCount:162,
		// 	createTime: '2023-03-15'
		// }, 
		{
			id: 2,
			cid: '8fbbbbe5-4575-4f16-95c5-d0bd67be7c1c',
			name: '智慧养老照护实训项目',
			textContext: ' 利用信息化手段虚拟仿真全照护过程，使照护情节与现实贴近。以老年人为中心进行系统规划，按照老年人的身体状况, 全方位满足教师教学、学生学习、在职培训和社会学习者自主学习的需求。 ',
			address: 'http://fz.scuvc.edu.cn',
			loginID: '学生账号',
			password: '学生密码',
			viewCount: 458,
			createTime: '2023-03-15'
		},
		// {
		// 	id: 3,
		// 	cid: 'ab4b1b6e-1e81-4a57-bb2f-9605c4820a5f',
		// 	name: '养老院火灾逃生仿真体验项目',
		// 	textContext: '根据消防的三知四会一通来进行标准的火灾训练；环境空间设计：根据先进的养老机构布局进行空间设计，从居室，卫生间，走廊，餐厅，消防通道等功能分区进行设计。对逃生的流程和灭火器的应用做出了交互训练。',
		// 	address: 'http://fz.scuvc.edu.cn',
		// 	loginID: 'student',
		// 	password: '123456',
		// 	viewCount: 458,
		// 	createTime: '2023-03-15'
		// }, 
		{
			id: 4,
			name: '赛训技能视听交互式学习项目',
			cid: 'e22df4a8-a7f3-43c9-a590-82ad9846f526',
			textContext: '交互式教学课件可在线实现互动学习的学习型课件',
			address: 'http://fz.scuvc.edu.cn',
			loginID: '学生账号',
			password: '学生密码',
			viewCount: 258,
			createTime: '2023-03-15'
		}, {
			id: 5,
			name: '老年人疾病智能认知学习项目',
			cid: 'e8a7b464-b3fc-4b40-a076-964dd65be08e',
			textContext: '系统内包含23种老年常见疾病，分别是肺炎，慢性支气管炎，肺气肿，骨质疏松，肩周炎，膝关节炎，肠易激综合征，消化性胃溃疡，阿兹海默症，脑梗，脑中风，帕金森，颈椎病，高血压，冠心病，糖尿病，高脂血症，高尿酸血症，黄斑性病变，白内障，青光眼，飞蚊症，老花眼。包含逼真的虚拟器官，以三维模型、视频或图片形式呈现。内容包含概述、病因、病症、病理演示、诊断检查、治疗、日常、知识问答、神经系统类疾病包含真实体验。',
			address: 'http://fz.scuvc.edu.cn',
			loginID: '学生账号',
			password: '学生密码',
			viewCount: 123,
			createTime: '2023-03-15'
		}, {
			id: 6,
			name: '智慧养老思政数字博物馆项目',
			cid: '9543dcdc-705a-4c1d-be19-25402c74141f',
			textContext: '包含九大展厅：习近平思想、党史、国史、社会主义发展史、改革开放史、党建名词、不忘初心、理论修养、党风廉政。',
			address: 'http://fz.scuvc.edu.cn',
			loginID: '学生账号',
			password: '学生密码',
			viewCount: 79,
			createTime: '2023-03-15'
		}, {
			id: 7,
			name: '养老社区沉浸式漫游项目',
			cid: '508f2449-410b-41fc-b08f-ac685a7a866b',
			textContext: '以三维虚拟社区驿站的形式展现，漫游系统中包含：接待区、康复训练室、老年餐桌和食堂、老年多功能活动室、音乐照护活动室等场景 ',
			address: 'http://localhost:8081',
			loginID: 'student',
			password: '123',
			viewCount: 31,
			createTime: '2023-03-15'
		}, {
			id: 8,
			name: '适老化居家环境创设项目',
			cid: '3b17c4c0-cba1-4cea-87c6-99b7bedf658e',
			textContext: '通过三维虚拟现实技术进行场景还原，进行老年人居家家具设计摆放。无需受到实地场景或家具的限时，可实时进行游戏化虚拟仿真练习。',
			address: 'http://fz.scuvc.edu.cn',
			loginID: '学生账号',
			password: '学生密码',
			viewCount: 421,
			createTime: '2023-03-15'
		}, {
			id: 9,
			name: '老年人能力评估实训项目',
			cid: '49fa1829-0471-4e47-81ae-2d428dd7e9bc',
			textContext: '依据最新的（GB）老年人能力评估规范研发,本系统包括评估信息表、评估对象基本信息表、信息提供者及联系人信息表、疾病诊断和用药情况、健康相关问题、老年人能力评估表、基础运动能力评估表、精神状态评估表、感知觉与社会参与评估表、老年人能力等级划分、老年人能力评估报告。',
			address: 'http://fz.scuvc.edu.cn',
			loginID: '学生账号',
			password: '学生密码',
			viewCount: 64,
			createTime: '2023-03-15'
		}
	],
	zaijian: [{
		id: 1,
		name: '在建项目名称1',
		viewCount: 15,
		createTime: '2023-03-15'
	}, {
		id: 2,
		name: '在建项目名称2',
		viewCount: 68,
		createTime: '2023-03-15'
	}, {
		id: 3,
		name: '在建项目名称3',
		viewCount: 71,
		createTime: '2023-03-15'
	}, {
		id: 4,
		name: '在建项目名称4',
		viewCount: 39,
		createTime: '2023-03-15'
	}, {
		id: 5,
		name: '在建项目名称5',
		viewCount: 78,
		createTime: '2023-03-15'
	}, {
		id: 6,
		name: '在建项目名称6',
		viewCount: 24,
		createTime: '2023-03-15'
	}],
	nijian: [{
		id: 1,
		name: '拟建项目名称1',
		viewCount: 16,
		createTime: '2023-03-15'
	}, {
		id: 2,
		name: '拟建项目名称2',
		viewCount: 9,
		createTime: '2023-03-15'
	}, {
		id: 3,
		name: '拟建项目名称3',
		viewCount: 28,
		createTime: '2023-03-15'
	}, {
		id: 4,
		name: '拟建项目名称4',
		viewCount: 47,
		createTime: '2023-03-15'
	}, {
		id: 5,
		name: '拟建项目名称5',
		viewCount: 3,
		createTime: '2023-03-15'
	}, {
		id: 6,
		name: '拟建项目名称6',
		viewCount: 12,
		createTime: '2023-03-15'
	}]
}